import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initial: 'G',
  name: 'Gabriel T.',
  role: 'Usuario de scooter eléctrico, Buenos Aires',
  text: 'Mega Kit Scooter transformó por completo mi forma de mantener mi scooter. Las plantillas de diagnóstico y el protocolo de inspección me dieron la estructura que siempre busqué y nunca encontré en un solo lugar. Lo recomiendo a cualquier rider que quiera rodar con más orden, seguridad y profesionalismo.'
}, {
  initial: 'M',
  name: 'Marcela R.',
  role: 'Reparadora independiente',
  text: 'El Tomo VI, el del negocio, me cambió la cabeza. Nunca había dimensionado cómo monetizar mi conocimiento sin tener un taller formal. Ahora trabajo desde casa con una cartera de clientes fijos y un tarifario claro. La tranquilidad que me dio es impagable.'
}, {
  initial: 'D',
  name: 'Diego F.',
  role: 'Especialista en scooters eléctricos',
  text: 'El tomo de sistema eléctrico es exactamente lo que necesitaba. Tengo scooters con configuraciones complejas y ahora puedo diagnosticar todo desde un solo protocolo. Claro, organizado y profesional. Me ahorra horas de prueba y error.'
}, {
  initial: 'L',
  name: 'Laura P.',
  role: 'Repartidora urbana',
  text: 'La guía de emergencias en ruta me dio seguridad ante situaciones que antes me generaban mucha tensión. El protocolo de fallas críticas especialmente es una herramienta que todo rider debería tener en el celular. Ya me salvó dos veces.'
}, {
  initial: 'N',
  name: 'Natalia G., 38 años',
  role: 'Tallerista, Córdoba',
  text: 'Desde que uso el Mega Kit, mis presupuestos y órdenes de trabajo me llevan la mitad del tiempo. Es una herramienta imprescindible para cualquiera que quiera profesionalizar su taller.'
}];
export function Testimonials() {
  return <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-125">
      <h2 className="text-3xl md:text-5xl font-bold text-center mb-8 md:mb-16" data-id="element-126">
        Lo que dicen los{' '}
        <span className="text-[#00b8ff]" data-id="element-127">riders y técnicos</span>
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-128">
        {testimonials.map((t, i) => <div key={i} className="bg-zinc-900 p-4 md:p-6 rounded-2xl border border-zinc-800 flex flex-col relative" data-id="element-129">
            <Quote className="absolute top-3 right-3 md:top-4 md:right-4 w-5 h-5 md:w-6 md:h-6 text-zinc-700" data-id="element-130" />
            <div className="flex text-yellow-400 mb-3 md:mb-4" data-id="element-131">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-132" />)}
            </div>
            <p className="text-sm md:text-base text-zinc-300 mb-4 md:mb-6 flex-grow leading-relaxed" data-id="element-133">
              "{t.text}"
            </p>
            <div className="flex items-center gap-3 mt-auto pt-3 md:pt-4 border-t border-zinc-800" data-id="element-134">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#00b8ff] flex items-center justify-center font-bold text-white shrink-0" data-id="element-135">
                {t.initial}
              </div>
              <div data-id="element-136">
                <p className="font-bold text-white text-sm" data-id="element-137">{t.name}</p>
                <p className="text-xs text-zinc-500" data-id="element-138">{t.role}</p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}